import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {makeStyles} from "@mui/styles";
import {useEffect, useState} from "react";


const Form_SB_28 = ({matterContacts, selectedMatter, selectedForm, xfaCombinedData, setXfaCombinedData, xfaGeneratedForm, modify}) => {
    const [matterRecords, setMatterRecords] = useState([]);
    const [checked, setChecked] = useState({});
    const [attorneyId, setAttorneyId] = useState("");
    const [attorneyName, setAttorneyName] = useState("");
    const [attorneyRefNo, setAttorneyRefNo] = useState("");
    const [selectedXfa, setSelectedXfa] = useState({});

    useEffect(() => {
        if (modify) {
            const selectedItem = xfaCombinedData?.find((xfaData) => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
            if (selectedItem) {
                selectedItem.matter_records = xfaGeneratedForm?.signatories?.length > 0 && xfaGeneratedForm?.signatories?.map((item) => item) || [];
                setSelectedXfa(selectedItem);
            }
        }
    }, []);

    useEffect(() => {
        if (!modify && matterContacts?.length) {
            const contact = matterContacts.find(({party_type, sequence_no}) => party_type === "Attorney" && sequence_no === 1);
            const item = {
                matter_records: contact ? [{
                    id: contact.party.id,
                    name: contact.party.name
                }] : []

            };
            setSelectedXfa(item);
            if (contact) {
                setMatterRecords([{id: contact.party.id, name: contact.party.name, referenceNo: contact.party.reference_no}]);
                setXfaCombinedData((previousData) => {
                    const newData = JSON.parse(JSON.stringify(previousData));

                    const item = newData?.find(
                        (xfaData) => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter
                    );

                    if (item) {
                        item.matter_records = [{id: contact.party.id, name: contact.party.name, referenceNo: contact.party.reference_no}];
                    }

                    return newData;
                });
            }
        }
    }, [matterContacts]);

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find((xfaData) => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
        setSelectedXfa(selectedItem);
    }, [xfaCombinedData, selectedMatter, selectedForm]);

    const handleClick = (e) => {
        setAttorneyId(e.target.value);
        let selectedContact = matterContacts.find((p) => p.party.id === e.target.value);
        setAttorneyName(selectedContact?.party.name);
        setAttorneyRefNo(selectedContact?.party.reference_no);
    };

    const handleAddClick = () => {
        const selectedContact = matterContacts.find((p) => p.party.id === attorneyId);
        const first_name = selectedContact?.party.first_name;
        const middle_name = selectedContact?.party.middle_name;
        const last_name = selectedContact?.party.last_name;

        setMatterRecords([...matterRecords, {id: attorneyId, name: attorneyName, referenceNo: attorneyRefNo}].filter(r => !!Object.keys(r).length));

        setXfaCombinedData((previousData) => {
            const newData = JSON.parse(JSON.stringify(previousData));

            const item = newData?.find(
                (xfaData) => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter
            );

            if (item) {
                if (!item.matter_records) {
                    item.matter_records = [];
                }
                item.matter_records.push({id: attorneyId, name: attorneyName, first_name, middle_name, last_name, referenceNo: attorneyRefNo});
                item.matter_records = item.matter_records.filter(r => !!Object.keys(r).length);
            }

            return newData;
        });

        setAttorneyId("");
        setAttorneyName("");
        setAttorneyRefNo("");
        setChecked({});
    };

    const handleDeleteClick = () => {
        let selectedIds = Object.keys(checked)?.filter(key => checked[key] === true) || [];
        let updatedMatterRecords;
        if (modify) {
            updatedMatterRecords = selectedXfa?.matter_records?.filter(record => !selectedIds.includes(`${record.name}_${record.referenceNo ? record.referenceNo : ""}`));
        } else {
            updatedMatterRecords = matterRecords?.filter(record => !selectedIds.includes(record.id.toString()));
        }
        setMatterRecords(updatedMatterRecords.filter(r => !!Object.keys(r).length));

        setXfaCombinedData((previousData) => {
            const newData = JSON.parse(JSON.stringify(previousData));
            const item = newData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

            if (item) {
                item.matter_records = updatedMatterRecords.filter(r => !!Object.keys(r).length);
            }

            return newData;
        });
    };

    const handleCheck = e => {
        setChecked({...checked, [e.target.id]: e.target.checked});
    };

    const filterMatterContacts = (item, index, self) => {
        const isUnique = self.findIndex(i => i.party.name === item.party.name) === index;
        if (!isUnique) {
            return false;
        }
        if (item.party_type === "Attorney" && !selectedXfa?.matter_records?.find(record => record.name === item.party.name)) {
            return true;
        }
    };

    const useStyles = makeStyles({
        table: {
            border: "1px solid black"
        },
        row: {
            "&:nth-of-type(odd)": {
                backgroundColor: "#F5F5F5"
            },
            "&:nth-of-type(even)": {
                backgroundColor: "white"
            }
        }
    });

    const classes = useStyles();

    return (
        <div style={{
            width: "100%"
        }}>
            <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#D3D3D3", color: "black", padding: 0}}>
                <Box/>
                <Box>Form SB-28</Box>
            </Box>
            <TableContainer>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell style={{width: "20%", padding: "0.5 0.5"}}>Signatory Details</TableCell>
                            <TableCell style={{width: "80%", padding: "0.5 0.5"}}>
                                <FormControl fullWidth>
                                    <Select size="small" value={attorneyId} onChange={(e) => handleClick(e)} displayEmpty renderValue={attorneyId !== "" ? undefined : () => "Select the Signatory"}>
                                        {matterContacts?.filter((contact, index, self) => filterMatterContacts(contact, index, self)).length === 0 ?
                                            <MenuItem value="">No signatories available</MenuItem> :
                                            matterContacts
                                                ?.filter((contact, index, self) => filterMatterContacts(contact, index, self))
                                                .map(item => <MenuItem key={item.id} value={item.party.id}>{item.party.name}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {modify ?
                            selectedXfa?.matter_records?.length > 0 && selectedXfa?.matter_records.filter(item => Boolean(item.name)).map((item, i) => (
                                <TableRow key={`${item.name} ${i}`} className={classes.row}>
                                    <TableCell>
                                        <Checkbox id={`${item.name}_${item.referenceNo ? item.referenceNo : ""}`} checked={checked[`${item.name}_${item.referenceNo ? item.referenceNo : ""}`]} onChange={e => handleCheck(e)}/>
                                    </TableCell>
                                    <TableCell style={{width: "20%"}}>{`Signatory ${i + 1}`}</TableCell>
                                    <TableCell style={{width: "80%"}}>{item.name}</TableCell>
                                </TableRow>
                            )) :
                            (selectedXfa?.matter_records?.length > 0 && selectedXfa?.matter_records.map((item, i) => (
                                <TableRow key={`${item.name} ${i}`} className={classes.row}>
                                    <TableCell>
                                        <Checkbox id={item.id} checked={checked[item.id] || false} onChange={e => handleCheck(e)}/>
                                    </TableCell>
                                    <TableCell style={{width: "20%"}}>{`Signatory ${i + 1}`}</TableCell>
                                    <TableCell style={{width: "80%"}}>{item.name}</TableCell>
                                </TableRow>
                            )))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <br/>
            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <Button variant="contained" color="primary" onClick={handleDeleteClick} disabled={Object.keys(checked).filter(p => checked[p] === true).length === 0}>DELETE</Button>
                <span style={{marginRight: "2%"}}></span>
                <Button variant="contained" color="primary" onClick={handleAddClick} disabled={!attorneyId}>ADD</Button>
            </div>
        </div>
    );
};

export default Form_SB_28;